import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { localize } from 'core/localization';
import { ShapedIcon, Collapse, Delay, Text } from 'components/common';
import { ICON, SIZES } from 'constants/components';
import Contents from 'components/contents/Contents';
import ContentBlock from 'components/contents/ContentBlock';

export class Feedback extends PureComponent {
  refFeedback;

  onShown = () => {
    const { onShown } = this.props;
    if (onShown) {
      onShown();
      this.refFeedback.focus();
    }
  };

  onHidden = () => {
    const { onHidden } = this.props;
    if (onHidden) onHidden();
  };

  render() {
    const { animate, delay, isExpanded } = this.props;
    if (!animate) {
      this.onShown();
      return this.renderContent();
    }

    return (
      <Delay wait={delay}>
        <Collapse
          delayOpacityTransition={true}
          trackDomChanges={true}
          isExpanded={isExpanded}
          onExpanded={this.onShown}
          onCollapsed={this.onHidden}
          scrollIntoView={true}
        >
          {this.renderContent()}
        </Collapse>
      </Delay>
    );
  }

  renderContent = () => {
    const { isCorrect, isSurvey, isOpenQuestionType, items, role } = this.props;
    return (
      <ContentBlock
        role={role}
        tabIndex={1}
        ariaLabel={getTitle(isCorrect, isSurvey, isOpenQuestionType)}
        contentRef={node => {
          this.refFeedback = node;
        }}
      >
        <ContentBlock.Icon>
          <ShapedIcon
            name={isCorrect ? 'ok' : 'close'}
            color={'buttonTextColor'}
            shapeColor={isCorrect ? 'correctColor' : 'incorrectColor'}
            size={SIZES.LARGE}
            shape={ICON.SHAPES.ROUND_FULL_COLOR}
          />
        </ContentBlock.Icon>
        <ContentBlock.Title>
          <Text appearance="h4">{getTitle(isCorrect, isSurvey, isOpenQuestionType)}</Text>
        </ContentBlock.Title>
        {items.length > 0 && (
          <ContentBlock.Content>
            <Contents items={items} />
          </ContentBlock.Content>
        )}
      </ContentBlock>
    );
  };
}

function getTitle(isCorrect, isSurvey, isOpenQuestionType) {
  if (isOpenQuestionType && isCorrect) {
    return localize('[your answer has been stored]');
  }
  if (isOpenQuestionType && !isCorrect) {
    return localize('[your answer is empty and was not stored]');
  }
  return localize(
    isSurvey ? '[your answer has been stored]' : isCorrect ? '[thats correct]' : '[thats incorrect]'
  );
}

Feedback.propTypes = {
  isCorrect: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  isSurvey: PropTypes.bool,
  delay: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  animate: PropTypes.bool.isRequired,
  onShown: PropTypes.func,
  onHidden: PropTypes.func,
  isExpanded: PropTypes.bool,
  isOpenQuestionType: PropTypes.bool,
  role: PropTypes.string
};

Feedback.defaultProps = {
  delay: 0,
  duration: 200,
  animate: true
};

export default Feedback;
